<template>
  <div>
    <div id="bg"></div>
    <div id="wrap">
      <ul class="blind">
        <li>
          <a href="#contents">본문 바로가기(Skip Contents)</a>
        </li>
      </ul>
      <SubHeader title="Live Quiz" />
      <!-- //header -->

      <div id="container" ref="container">
        <section id="contents">
          <div class="qnaWrap list-style">
            <ul class="qnalistCon">
              <li>
                <div class="qnatitle">
                  <h3>{{writer}}</h3>
                  <p>
                    <span>{{mdate}}</span>
                    {{mtime}}
                  </p>
                </div>
                <div class="con">
                  <p>{{this.$store.getters.getQnaView.text}}</p>
                  <div class="info">
                    <div class="left">
                      <a href @click.prevent="likeit">
                        <img src="@/assets/img/heart.png" alt="좋아요" />
                        {{likesCount}}
                      </a>
                      <a href @click.prevent="dummy">
                        <img src="@/assets/img/comment.png" alt="댓글" />
                        {{commentsCount}}
                      </a>
                    </div>
                    <div class="right" v-if="isOwner">
                      <a href class="modify" @click.prevent="goQnaEdit">
                        <img src="@/assets/img/modify_icon.png" alt="수정" />
                      </a>
                      <a href="#" class="delete" @click.prevent="toggleDeletePanel">
                        <img src="@/assets/img/delete_icon.png" alt="삭제" />
                      </a>
                    </div>
                  </div>
                  <!-- 
                                삭제 또는 수정 버튼 클릭시 노출
                  -->
                  <div class="alertM" :style="deletePanelStyle">
                    <p>삭제하시겠습니까?</p>
                    <div class="btnWrap">
                      <a href="#" class="submit" @click.prevent="goQnaDelete">확인</a>
                      <a href="#" class="cancel" @click.prevent="toggleDeletePanel">취소</a>
                    </div>
                  </div>
                </div>
              </li>
            </ul>

            <!-- qnaView -->
            <div class="qnaComment">
              <div class="qnaCommentTitle">
                <img src="@/assets/img/comment.png" alt="댓글" /> 댓글
                <span>{{commentsCount}}</span>
              </div>
              <ul>
                <Comment
                  v-bind:key="comment.id"
                  :comment="comment"
                  :qna_id="qna_id"
                  v-for="comment in this.$store.getters.getQnaView.Qnacomments"
                />
              </ul>
              <a href class="more" style="display:none;">
                더보기
                <img src="@/assets/img/more_icon.png" alt="더보기" />
              </a>
            </div>

            <div class="commentWrite">
              <input type="text" v-model="comment" maxlength="30" placeholder="댓글 달기 (30자 이내)" />
              <a href="#" @click.prevent="goCommentSave">입력</a>
            </div>
          </div>
          <!-- qnaWrap -->
        </section>
        <!-- //contents -->
      </div>
      <!-- //container -->
    </div>
    <!-- //wrap -->
  </div>
</template>

<script>
import Comment from "@/components/qna/Comment";
import SubHeader from "@/components/SubHeader";
import sideMixin from "@/components/SideMixin";
import * as R from "ramda";
export default {
  mixins: [sideMixin],
  components: { Comment, SubHeader },
  created() {
    let qna_id = this.$route.params.qnaid;
    this.$store.dispatch("loadQnaView", qna_id);
  },
  computed: {
    mdate: function() {
      return this.moment(this.$store.getters.getQnaView.createdAt).format(
        "MM-DD"
      );
    },
    mtime: function() {
      return this.moment(this.$store.getters.getQnaView.createdAt).format(
        "hh:mm"
      );
    },
    likesCount: function() {
      return this.$store.getters.getQnaView.Qnalikes.length;
    },
    writer() {
      return this.$store.getters.getQnaView.writer;
    },
    commentsCount: function() {
      return this.$store.getters.getQnaView.Qnacomments.length;
    },
    isOwner() {
      return (
        this.$store.getters.getQnaView.writer ===
        this.$store.getters.getDefaultInfo
      );
    },
    deletePanelStyle() {
      if (this.isOpendDeletePanel) {
        return "display:block;";
      } else {
        return "display:none;";
      }
    }
  },
  data: function() {
    return {
      comment: "",
      isOpendDeletePanel: false,
      qna_id: this.$route.params.qnaid
    };
  },
  methods: {
    dummy() {},
    goCommentSave: function() {
      let qna_id = this.$route.params.qnaid;
      let url = this.$Constant.QnaCommentApi;
      let text = this.comment;
      let $self = this;

      if (text.trim().length === 0) {
        alert("덧글을 입력해 주세요");
        return;
      }

      this.$axios
        .post(url, {
          writer: localStorage.getItem("default_info"),
          text: text,
          qna_id: qna_id
        })
        .then(resp => {
          let qna_id = $self.$route.params.qnaid;
          $self.$store.dispatch("loadQnaView", qna_id);
          this.comment = "";

          let payload = resp.data;
          payload.comment_id = payload.id;
          payload.classroom_id = this.$store.getters.getClassroomId;
          let wrapper = {};
          wrapper.wayto = "ACTION_QNA_COMMENTADD";
          wrapper.from = "";
          wrapper.to = "";
          wrapper.payload = payload;
          this.$store.dispatch("pushWSMessage", wrapper);
        });
    },
    goQnaEdit() {
      let paperid = this.$store.getters.getQnaView.paper_id;
      let qnaid = this.$route.params.qnaid;
      this.$router.push(`/qna/write/${paperid}/${qnaid}`);
    },
    goQnaDelete() {
      let url = this.$Constant.QnaListGetApi;
      let $self = this;
      let qna_id = $self.$route.params.qnaid;

      this.$axios.delete(`${url}/${qna_id}`).then(resp => {
        let paperid = $self.$store.getters.getQnaView.paper_id;
        $self.$router.push(`/qna/list/${paperid}`);

        let payload = resp.data;
        payload.qna_id = qna_id;
        payload.id = qna_id;

        payload.classroom_id = this.$store.getters.getClassroomId;
        let wrapper = {};
        wrapper.wayto = "ACTION_QNA_REMOVE";
        wrapper.from = "";
        wrapper.to = "";
        wrapper.payload = payload;
        this.$store.dispatch("pushWSMessage", wrapper);
      });
    },
    goCommentDelete(comment) {
      let url = this.$Constant.QnaCommentApi;
      let $self = this;
      this.$axios.delete(`${url}/${comment.id}`).then(() => {
        let qna_id = $self.$route.params.qnaid;
        $self.$store.dispatch("loadQnaView", qna_id);
      });
    },
    toggleDeletePanel() {
      this.isOpendDeletePanel = !this.isOpendDeletePanel;
    },
    likeit() {
      let url = this.$Constant.QnaLikeApi;
      let qna_id = this.$route.params.qnaid;

      let like_toggle = this.$store.state.qna_view.like_toggle;
      let writer = localStorage.getItem("default_info");

      if (like_toggle) {
        // got a thumb up  already

        let myLikeit = R.find(R.propEq("writer", writer))(
          this.$store.state.qna_view.Qnalikes
        );

        this.$axios.delete(url + "/" + myLikeit.id).then(resp => {
          this.$store.state.qna_view.like_toggle = false;
          //todo: remove likeit from  sate.qnaLikes
          let _likes = R.reject(R.propEq("writer", writer))(
            this.$store.state.qna_view.Qnalikes
          );
          this.$store.state.qna_view.Qnalikes = _likes;

          let wrapper = {};
          let payload = resp.data;
          payload.qna_id = this.$route.params.qnaid;
          payload.classroom_id = this.$store.getters.getClassroomId;

          wrapper.wayto = "ACTION_QNA_LIKEREMOVE";
          wrapper.from = "";
          wrapper.to = "";
          wrapper.payload = payload;
          this.$store.dispatch("pushWSMessage", wrapper);
        });
      } else {
        this.$axios
          .post(url, {
            writer: writer,
            qna_id: qna_id
          })
          .then(resp => {
            this.$store.state.qna_view.Qnalikes.push(resp.data);
            this.$store.state.qna_view.like_toggle = true;

            let payload = resp.data;
            payload.qna_id = this.$route.params.qnaid;
            payload.classroom_id = this.$store.getters.getClassroomId;
            let wrapper = {};
            wrapper.wayto = "ACTION_QNA_LIKEADD";
            wrapper.from = "";
            wrapper.to = "";
            wrapper.payload = payload;
            this.$store.dispatch("pushWSMessage", wrapper);
          });
      }
    }
  }
};
</script>



